import React, { useState, useEffect } from 'react';
import { t, Trans } from '@lingui/macro';
import Modal from '@mos-cat/modal';
import Radio from '@mos-cat/radio';
import { Dispatch } from 'redux';
import { connect } from 'dva';

import { Button, Heading } from '@mos-cat/typography';
import Link from '../../shared/Link/Link';

import { childrenModalOpen } from '../../../models/modals';
import './ChildrenModal.pcss';
import { getHiddenChildren } from '../../../selectors/children';
import { i18n } from '../../../helpers/i18n';
import { scrollToTop } from '../../../helpers/findScrollableParent';

interface ChildrenModalProps {
  childrenModalOpen: boolean;

  onModalClose(): void;

  onAddChild(id: string): void;

  children: any;
}

function ChildrenModal({
  childrenModalOpen,
  onModalClose,
  onAddChild,
  children,
}: ChildrenModalProps) {
  const childNotFromList = i18n._(t`Ребёнка нет в списке`);
  const [active, setActive] = useState('');

  useEffect(() => {
    if (childrenModalOpen)
      setTimeout(() => scrollToTop('.ChildrenModal .Modal-body'), 500);
  }, [childrenModalOpen]);

  const onChange = ({ target: { value } }) => {
    setActive(value);
  };
  const handleAddChild = () => {
    onAddChild(active);
    setActive('');
  };
  if (!children.length) return null;

  return (
    <Modal
      headerContent={
        <Heading level={3} className="ChildModal__Title">
          <Trans>Выберите ребёнка</Trans>
        </Heading>
      }
      visible={childrenModalOpen}
      onClose={onModalClose}
      className="ChildrenModal"
    >
      <div className="ChildrenModal__content">
        <div className="ChildrenModal__text">
          <Trans>
            Данные детей из списка уже заполнены в{' '}
            <Link href={i18n._(t`https://my.mos.ru/my/`)} target="_blank">
              Личном кабинете
            </Link>{' '}
          </Trans>
        </div>
        {children.map((child) => {
          const {
            fullName,
            birthdate: { value },
            id,
          } = child;
          const label = (
            <div className="ChildrenModal__name">
              {fullName}
              <span className="ChildrenModal__date">{value}</span>
            </div>
          );

          return (
            <div className="PguFormGrid__row" key={id}>
              <Radio
                className="PguFormGrid_col ym-hide-content"
                label={label}
                name="activeChild"
                value={id}
                checked={active === id}
                onChange={onChange}
              />
            </div>
          );
        })}
        <div className="PguFormGrid__row">
          <Radio
            label={childNotFromList}
            name="activeChild"
            value={childNotFromList}
            checked={active === childNotFromList}
            onChange={onChange}
          />
        </div>
      </div>
      <div className="ChildModal__footer">
        <div className="ChildModal__buttons ChildModal__buttons_left">
          <Button
            className="ChildModal__addBtn"
            primary
            onClick={handleAddChild}
          >
            <Trans>Добавить ребёнка</Trans>
          </Button>
          <button
            type="button"
            className="ChildModal__cancelBtn mos-link"
            onClick={onModalClose}
          >
            <Trans>Отменить</Trans>
          </button>
        </div>
      </div>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onAddChild(payload) {
    dispatch({
      type: 'children/edit',
      payload,
    });
    dispatch(childrenModalOpen(false));
  },
  onModalClose() {
    dispatch(childrenModalOpen(false));
  },
});

export default connect((state) => {
  return {
    children: getHiddenChildren(state),
    childrenModalOpen: state.modals.childrenModalOpen,
  };
}, mapDispatchToProps)(ChildrenModal);
